__turbopack_context__.v({
  "checkIcon": "Checkbox-module__mx8N2q__checkIcon",
  "checkboxContainer": "Checkbox-module__mx8N2q__checkboxContainer",
  "checked": "Checkbox-module__mx8N2q__checked",
  "customCheckbox": "Checkbox-module__mx8N2q__customCheckbox",
  "disabled": "Checkbox-module__mx8N2q__disabled",
  "disabledLabel": "Checkbox-module__mx8N2q__disabledLabel",
  "input": "Checkbox-module__mx8N2q__input",
  "inputWrapper": "Checkbox-module__mx8N2q__inputWrapper",
  "label": "Checkbox-module__mx8N2q__label",
  "large": "Checkbox-module__mx8N2q__large",
  "small": "Checkbox-module__mx8N2q__small",
});
